import React, {useContext} from "react";
import Button from "../../../components/Button";
import useModal from "../../../hooks/useModal";
import WithdrawModal from "../../Farm/components/WithdrawModal";
import {Farm} from "../../../contexts/Farms/types";
import BigNumber from "bignumber.js";
import useUnstake from "../../../hooks/useUnstake";
import {FarmContext} from "../../../contexts/farm_provider/farm_provider";
import {StakeButton} from "./reward";
import {useWallet} from "use-wallet";
import {UserAccoutContext} from "../../../contexts/farm_provider/user_account_provider";


export const UnStake: React.FC = () => {
    const {onUnstake} = useUnstake(); // 取出 Fn
    const {ethAmout} = useContext(UserAccoutContext);

    const model: Farm = useContext(FarmContext);
    const [onPresentWithdraw] = useModal(
        <WithdrawModal
            max={model.tokenBalance}
            onConfirm={onUnstake}
            tokenName={model.name}
        />,
    );

    return (<StakeButton
        disabled={model.tokenBalance.eq(new BigNumber(0)) || model.isPause ||     ethAmout.eq(0)}
        text="Withdraw"
        size="sm"
        onClick={onPresentWithdraw}
    />);
};
